import { createFileRoute } from "@tanstack/react-router"
import { ClientHeader } from "@/components/client-header"
import { ClientTabNavigation } from "@/components/client-tab-navigation"
import { Page } from "@/components/page"
import { EstateNextStepsReport } from "@/components/reports/nextSteps"

export const Route = createFileRoute(
  "/_authed/_professional/professional/reports/next-steps/$estateId",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { estateId } = Route.useParams()

  return (
    <Page
      headerSlot={<ClientHeader estateId={estateId} />}
      tabSlot={<ClientTabNavigation estateId={estateId} />}
    >
      <EstateNextStepsReport estateId={estateId} />
    </Page>
  )
}
